import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";

import ActionButtonLayout from "../layout/ActionButtonLayout";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import ConfirmDialog from "../dialogTypes/ConfirmDialog";

import notificationState from "../../states/notificationState";
import apiClient from "../../lib/common/apiClient";

function DbTransactions(props) {

    const { t } = useTranslation ();

    const [ msg, setMsg ] = useState ();
    const [ disabled, setDisabled ] = useState ( true );
    const [ , setApi ] = useState ();
    const [ , setTransaction ] = useState ();
    const [ , setConfirmDialog ] = useState ();

    const setNotification = useSetRecoilState(notificationState);

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
        
    };

    const notifyFailure = (msg) => {
    
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
        
    };
    
    const onApiInitialized = ( api ) => {

        setApi ( api );

    };

    const onGridInitialized = ( grid ) => {

        grid.selectionChanged.addHandler ( ( grid, event ) => {

            if ( grid.selectedItems && grid.selectedItems[0] ) {

                setDisabled ( false );
                setTransaction ( grid.selectedItems[0] );

            } else {

                setDisabled ( true );
                setTransaction ( null );

            }

        } );

        grid.itemsSourceChanged.addHandler ( (grid, event) => {
 
            if ( grid.selectedItems && grid.selectedItems[0] ) {

                setDisabled ( false );
                setTransaction ( grid.selectedItems[0] );

            } else {

                setDisabled ( true );
                setTransaction ( null );

            }

        } );
    
    };

    const onConfirmDialogInitialized = ( dialog ) => {

        setConfirmDialog ( dialog );

    }

    const onClickKillProcess = () => {

        setTransaction ( ( transaction ) => {

            setMsg ( t ( "msg.killProcessConfirm", { id: transaction.trx_mysql_thread_id } ) );
            setConfirmDialog ( ( dialog ) => {
    
                dialog.show ();
                return dialog;
    
            } );

            return transaction;

        } );

    };

    const onConfirmed = ( data ) => {

        setTransaction ( ( transaction ) => {

            let id = transaction.trx_mysql_thread_id;

            apiClient.del ( `/api/DbProcess/${id}` )
                .then((result) =>  {

                    notifySuccess ( t ( "success.killProcessSuccess", { id } ) );

                    setApi ( ( api ) => {

                        api.refresh ();

                        return api;

                    } );

                } )
                .catch((reason) => {

                    notifyFailure ( t ( "error.killProcessFailed", { id } ) );

                } );
            
        } );

    };
    
    return <>

        <BasicCrudScreenType
            id="DbTransactions"
            table="VwDbTransactions"
            view="VwDbTransactions"
            noCreate
            noEdit
            noDelete
            noExcel
            onInitialized={onGridInitialized}
            onApiInitialized={onApiInitialized}
            onAppendButtonAtLast={ () =>     
                <>
        
                    <BasicCrudScreenActionItemLayout>
        
                        <ActionButtonLayout id="killProcess" disabled={disabled} onClick={onClickKillProcess}>{t("buttonName.killProcess")}</ActionButtonLayout>
        
                    </BasicCrudScreenActionItemLayout>
        
                </>
            }
        />
        <ConfirmDialog
            id={"kill-process-confirm-dialog"}
            title={ t("term.killProcess") }
            msg={msg}
            data={process}
            onOk={ () => onConfirmed () }
            onInitialized={onConfirmDialogInitialized}
        />

    </>;

}

export default DbTransactions;
